import { render, staticRenderFns } from "./ViewImg.vue?vue&type=template&id=447bd78c&"
import script from "./ViewImg.vue?vue&type=script&lang=js&"
export * from "./ViewImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports